import QueryString from "qs";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const useFilterParams = (initialValue?: Record<string, any>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const previousFiltersRef = useRef<Record<string, any>>({});

  const isValidValue = (value: any): boolean => {
    if (value === null || value === undefined) return false
    if (typeof value === 'string' && value.trim() === '') return false
    if (typeof value === 'object' && value.hasOwnProperty('value')) {
      return value.value !== null && value.value !== undefined && value.value !== ''
    }
    return true
  };

  const hasFiltersChanged = (newParams: any) => {
    const currentFiltersWithoutPage = { ...newParams };
    delete currentFiltersWithoutPage.page;

    const previousFiltersWithoutPage = { ...previousFiltersRef.current };
    delete previousFiltersWithoutPage.page;

    return JSON.stringify(currentFiltersWithoutPage) !== JSON.stringify(previousFiltersWithoutPage);
  };

  const setFilterParams = (mutationFn: (params: any) => any) => {
    const parsed = QueryString.parse(searchParams.toString());
    const newParams = Object.fromEntries(
      Object.entries(mutationFn(parsed)).filter(([_, value]) => isValidValue(value)),
    );

    const filtersChanged = hasFiltersChanged(newParams);

    if (filtersChanged && newParams.page && Number(newParams.page) > 1) {
      newParams.page = undefined;
    }

    previousFiltersRef.current = { ...newParams };

    setSearchParams(QueryString.stringify(newParams));
  };

  const filterParams = QueryString.parse(searchParams.toString()) as { [key: string]: any };

  useEffect(() => {
    if (initialValue && searchParams.toString() === '') {
      setSearchParams(
        QueryString.stringify(initialValue)
      );
    }
  }, []);

  return { filterParams, setFilterParams, queryString: searchParams.toString() };
};
